export default __webpack_public_path__ + "static/media/preloader.5788b05c.svg";